<script setup lang="ts">
import EmbedImage from '~/components/embeds/EmbedImage.vue'

/**
 * Props from the VGS section template in Ibexa:
 * ./templates/themes/vgs/svg/embed.html.twig
 */
defineProps<{
  src: string
  largeImageSrc?: string
  altText: string
  caption?: string
  imageSize?: string
  copyright?: string
  isSvg?: string
  magnifier?: string
}>()
</script>

<template>
  <EmbedImage
    :src
    :alt="altText"
    :caption="caption ?? ''"
    :copyright="copyright ?? ''"
  />
</template>
